import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "../../../hooks/customDeviceDetect";
import { cn } from "../../../util/classNameConstructor";
import Button from "../../core/button/Button";
import Icon from "../../core/icon/Icon";

const DrawingUiElements = ({
  mapType,
  statefulMap,
  inMainMap,
  continueFeat,
  featureId,
  handleDelete,
  handleSaveAll,
  handleContinueDrawingFromLastVertex,
  handleSetAddDescription,
  setContinueFeat,
  setOpenDescription,
  openDescription,
  descriptionProvided,
  showMessage,
  ...props
}) => {
  const { t } = useTranslation();
  const isMobileFallback = useIsMobile();
  const isMobile = props.isMobile ?? isMobileFallback;
  return (
    <>
      <div
        className={cn(
          "flex justify-center -order-1",
          isMobile ? "ms-auto" : "mx-auto",
        )}
      >
        {ReactDOM.createPortal(
          showMessage && !openDescription && (
            <div
              className={cn(
                !isMobile &&
                  "fixed top-[var(--h-progress-bar,0px)] start-0 w-[calc(var(--w-screen,100vw)/2)] p-3",
                isMobile && "fixed bottom-20 border-t",
              )}
            >
              <div
                className={cn(
                  "relative w-full h-auto flex pointer-events-all gap-2.5 transition-colors duration-200 bg-surface-default p-2.5 -order-1",
                  isMobile
                    ? "ms-auto border-b border-border-subdued"
                    : "rounded-lg border shadow-lg",
                )}
              >
                <Icon name="alert" className=" text-icon-critical shrink-0" />
                <span>
                  {t(
                    `map:drawInfoTooltip.maxFeaturesReached.${mapType.drawType}`,
                  )}
                </span>
              </div>
            </div>
          ),
          document.getElementById("survey-footer-container") || document.body,
        )}
        {featureId && (
          <div
            className={cn(
              "w-full h-auto flex flex-col pointer-events-all gap-2.5 transition-colors duration-200",
              inMainMap &&
                isMobile &&
                "fixed bottom-[200px] left-0 right-0 justify-center flex",
            )}
          >
            <div
              className={cn(
                "flex gap-2 w-full",
                inMainMap && isMobile && "justify-center",
              )}
            >
              {continueFeat &&
                statefulMap.df?.getMode() !== "custom_draw_line_string" && (
                  <Button
                    size="lg"
                    variant="white"
                    dataCy="drawingFeatureContinue"
                    onClick={() => {
                      handleContinueDrawingFromLastVertex(
                        statefulMap.df,
                        continueFeat,
                        setOpenDescription,
                      );
                      setContinueFeat(false);
                    }}
                    text={t("map:draw.continueDrawing")}
                  />
                )}
              <Button
                size="lg"
                variant="white"
                leadingIcon={isMobile && continueFeat ? "trash" : undefined}
                text={
                  isMobile && continueFeat
                    ? ""
                    : t("util:delete", {
                        val: t(
                          `global:${
                            mapType.drawType === "point"
                              ? "point"
                              : mapType.drawType === "path"
                                ? "path"
                                : "area"
                          }`,
                        ),
                      })
                }
                onClick={() => {
                  handleDelete(featureId);
                }}
              />
              <Button
                variant="primary"
                leadingIcon="checkmark-md"
                text={isMobile && continueFeat ? "" : t("global:save")}
                size="lg"
                disabled={
                  openDescription === true &&
                  !(typeof descriptionProvided === "object"
                    ? descriptionProvided[featureId]
                    : descriptionProvided)
                }
                disabledNotice={t("map:drawInfoTooltip.descriptionMissing")}
                dataCy="drawingFeatureSave"
                onClick={() => {
                  handleSetAddDescription(featureId, "save");
                  handleSaveAll(featureId);
                }}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default DrawingUiElements;
